import React, { useState, useEffect } from 'react';
import {
    Form,
    Card,
    Spin,
    Checkbox,
    Switch,
} from 'antd';

const StructureAndComponents = ({
                                     form,
                                     formValues,
                                     setFormValues,
                                     suggestedTemplates = [],
                                     allTemplates = [],
                                     allComponents = [],
                                     isLoading = false
                                 }) => {

    const [showAll, setShowAll] = useState(false);
    const [selectedComponents, setSelectedComponents] = useState([]);
    const templatesToRender = showAll ? allTemplates : suggestedTemplates;

    useEffect(() => {
        const formValues = form.getFieldValue('lessonPlanComponents');
        if (formValues) {
            setSelectedComponents(formValues);
        }
    }, [form]);

    const handleComponentChange = (checkedValues) => {
        setSelectedComponents(checkedValues);
    };

    const showLoading = !showAll && isLoading;

    const showEmptyMessage =
        (showAll && allTemplates.length === 0) ||
        (!showAll && !isLoading && suggestedTemplates.length === 0);

    const showTemplateList = !showLoading && !showEmptyMessage;

    let emptyTitle = "No Templates Found";
    let emptyMessage = "Could not find any templates matching your criteria. Try showing all templates.";
    if (showAll && allTemplates.length === 0) {
        emptyTitle = "No Templates Available";
        emptyMessage = "The lesson template configuration could not be loaded.";
    }

    return (
        <div>
            <div className={'ch-lpm-form-section'}>
                <h3>Lesson Structure</h3>
                <Form.Item label="Template Selection Mode">
                    <div className="ch-lpm-switch-container">
                        <Switch
                            checked={showAll}
                            onChange={setShowAll}
                            disabled={isLoading}
                        />
                        <span className="ch-lpm-switch-label">
                            {showAll ? "Showing all templates" : "Showing suggested only"}
                        </span>
                    </div>
                </Form.Item>

                {showLoading && (
                    <div>
                        <Spin description="Finding the best templates for your lesson..." size="large" />
                    </div>
                )}

                {showEmptyMessage && (
                    <div>
                        <h4>{emptyTitle}</h4>
                        <p>{emptyMessage}</p>
                    </div>
                )}

                {showTemplateList && (
                    <>
                        <p>
                            {showAll
                                ? "Browse all available lesson structures."
                                : "Based on your initial choices, here are the best lesson structures for your goals."
                            }
                        </p>
                        <Form.Item label="Select a Lesson Template" name="lessonPlanTemplateId" rules={[{ required: true, message: 'Please select a lesson plan template.' }]}>
                            <div className="ch-lpm-template-list">
                                {templatesToRender.map(template => {
                                    const templateId = template.value || template.id;
                                    const templateLabel = template.label || template.displayName;
                                    const isSelected = formValues.lessonPlanTemplateId === templateId;

                                    return (
                                        <Card
                                            key={templateId}
                                            className={`ch-lpm-template-card ${isSelected ? 'selected' : ''}`}
                                            onClick={() => {
                                                form.setFieldsValue({ lessonPlanTemplateId: templateId });
                                                setFormValues(prev => ({ ...prev, lessonPlanTemplateId: templateId }));
                                            }}
                                        >
                                            <h4>{templateLabel}</h4>
                                            <p>{template.description}</p>
                                        </Card>
                                    );
                                })}
                            </div>
                        </Form.Item>
                    </>
                )}
            </div>

            <div className={'ch-lpm-form-section'}>
                <h3>Lesson Components</h3>
                <p>Uncheck any sections you don't need in the final lesson plan document.</p>
                <Form.Item
                    name="lessonPlanComponents"
                    rules={[{ required: true, message: 'Please select at least one component.' }]}
                >
                    <Checkbox.Group onChange={handleComponentChange} className="ch-lpm-components-group">
                        <div className="ch-lpm-components-grid">
                            {allComponents.map((component) => (
                                <label
                                    key={component.value}
                                    className={`ch-lpm-component-card ${selectedComponents.includes(component.value) ? 'checked' : ''}`}
                                >
                                    <div className="ch-lpm-component-card-content">
                                        <span className="ch-lpm-component-card-label">{component.label}</span>
                                        <Checkbox value={component.value} className="ch-lpm-component-checkbox" />
                                    </div>
                                </label>
                            ))}
                        </div>
                    </Checkbox.Group>
                </Form.Item>
            </div>
        </div>
    );
};

export default StructureAndComponents;
